// frontend/src/services/autoApprovalSettingsService.js
import api from './api';

const autoApprovalSettingsService = {
  /**
   * GET /admin/auto-approval/settings
   * Returns { enabled, constraints: { location, time, employee, technical, behavioral }, lastUpdated }
   */
  async getSettings() {
    const response = await api.get('/admin/auto-approval/settings');
    return response.data;
  },

  /**
   * PUT /admin/auto-approval/settings
   * Persists all constraint parameters + enabled flag.
   */
  async updateSettings(payload) {
    const response = await api.put('/admin/auto-approval/settings', payload);
    return response.data;
  },

  /**
   * POST /admin/auto-approval/toggle
   * Quick enable/disable without touching constraint config.
   */
  async toggle(enabled) {
    const response = await api.post('/admin/auto-approval/toggle', { enabled });
    return response.data;
  },

  /**
   * POST /admin/auto-approval/reset
   * Reset all settings to system defaults.
   */
  async resetToDefaults() {
    const response = await api.post('/admin/auto-approval/reset');
    return response.data;
  },

  /**
   * GET /admin/auto-approval/statistics
   * Returns { statistics: { total, approved, pending, rejected, autoApprovalRate } }
   */
  async getStatistics(filters = {}) {
    const response = await api.get('/admin/auto-approval/statistics', { params: filters });
    return response.data;
  },

  /**
   * GET /admin/auto-approval/preview
   * Returns constraint windows and example approval scenarios.
   */
  async getPreview() {
    const response = await api.get('/admin/auto-approval/preview');
    return response.data;
  },

  /**
   * POST /admin/auto-approval/test
   * Test constraints against a specific location/time (with optional real employee).
   */
  async testConstraints(payload) {
    const response = await api.post('/admin/auto-approval/test', payload);
    return response.data;
  }
};

export default autoApprovalSettingsService;
